<template>
  <div class="intro-push-container">
    <common-header></common-header>
    <div class="header-banner"></div>
    <!-- 推送平台价值 -->
    <common-advantage :advantages="valuesList"></common-advantage>
    <!-- 推送平台优势 -->
    <common-advantage :advantages="advantageList"></common-advantage>
    <!-- 推送功能介绍 -->
    <common-advantage :advantages="functionList"></common-advantage>
    <!-- 推送平台架构图 -->
    <div class="application-wrap resolution-wrap">
      <common-application title="推送平台架构图" :tabcontent="tabcontent"></common-application>
    </div>
    <!-- 推送平台应用案例 -->
    <div class="application-wrap appcase-wrap">
      <common-application title="推送平台应用案例" :tabfilter="tabsfilter2" :tabcontent="tabcontent2"></common-application>
    </div>
    <common-footer></common-footer>
  </div>
</template>
<script>
import mainHeader from '@/components/mainheader'
import mainFooter from '@/components/mainfooter'
import advantage from '@/components/advantage'
import application from '@/components/application'
export default {
  name: 'app',
  components: {
    'common-header': mainHeader,
    'common-footer': mainFooter,
    'common-advantage': advantage,
    'common-application': application
  },
  data () {
    return {
      tabsfilter2: ['汽车之家推送平台应用', '违章查询助手推送平台应用'],
      tabcontent: ['push-banner2'],
      tabcontent2: ['push-banner3', 'push-banner4'],
      currentTabIndex: 0,
      currentTabIndex2: 0,
      hoverIndex: -1,
      valuesList: {
        title: '推送平台价值',
        mulitrow: false,
        list: [
          {
            key: '0',
            title: '简化App接入工作',
            desc: '封装包含APNs、华为、小米、OPPO、VIVO、魅族、个推、阿里云、极光的推送渠道，推送配置及回执上报功能的推送SDK，方便App快速接入',
            iconname: 'icon-push-01'
          },
          {
            key: '1',
            title: '多维度推送支持',
            desc: '对接画像平台，可针对人群进行精准推送；支持直接上传设备进行推送；支持对不同用户或设备的独立推送',
            iconname: 'icon-push-02'
          },
          {
            key: '2',
            title: '多过滤规则支持',
            desc: '支持用户收到消息间隔、用户每日最大收到消息条数、单任务允许最大推送用户数等多维度过滤，保证用户的推送体验',
            iconname: 'icon-push-03'
          },
          {
            key: '3',
            title: '多维度效果统计',
            desc: '支持从任务维度、业务方维度、推送渠道维度，分析推送的发送、打开效果，方便推送数据分析及运营',
            iconname: 'icon-push-04'
          }
        ]
      },
      advantageList: {
        title: '推送平台优势',
        mulitrow: true,
        list: [
          {
            key: '0',
            title: '接入简单',
            desc: 'App简单接入推送SDK，即可完成主流推送渠道接入，进行推送运营及推送效果分析',
            iconname: 'icon-push-05'
          },
          {
            key: '1',
            title: '配置灵活',
            desc: '后台简单配置，即可实现新App的接入；推送协议及返回页都可通过模板配置，方便推送运营；业务方可配置不同过滤规则，使用不同推送策略',
            iconname: 'icon-push-06'
          },
          {
            key: '2',
            title: '推送成功率高',
            desc: '同时接入主流厂商及第三方推送渠道，多渠道复用，有效保证消息送达；采用备份推送渠道策略，主推送渠道失效时，快速切换为备份渠道',
            iconname: 'icon-push-07'
          }
        ]
      },
      functionList: {
        title: '推送功能介绍',
        mulitrow: true,
        list: [
          {
            key: '0',
            title: '推送SDK',
            desc: '封装APNs、华为、小米、OPPO、VIVO、魅族、个推、阿里云、极光推送渠道，简单集成，主流渠道全覆盖；封装推送配置上报，及时同步App推送状态变化；封装推送回执，收集推送到达及打开，方面后续分析',
            iconname: 'icon-push-08'
          },
          {
            key: '1',
            title: '用户画像维度推送',
            desc: '接入画像平台，有目的的圈选用户推送，消息推送给适合的人群，提升运营效果',
            iconname: 'icon-push-09'
          },
          {
            key: '2',
            title: '推送统计',
            desc: '支持从任务维度、业务方维度、推送渠道维度，分析推送的发送、打开效果，方便推送数据分析及运营',
            iconname: 'icon-push-10'
          }
        ]
      }
    }
  },
  created(){
    // pv上报
    // 埋点
    window.pvTrack = {
      site: 144,
      category: 1722,
    }
    window.trackPageView()
  },
  methods: {}
}
</script>

<style scoped>
.intro-push-container {
  background-color: #F7F9FA;
}
.header-banner {
  width: 100%;
  height: 542px;
  background-size: cover;
  background-image: url('./../assets/images/index-banner_push.png');
  background-repeat: no-repeat;
  background-position: -2px 0;
  position: relative;
  top: -1px;
}
.application-wrap {
  margin-bottom: -2px;
}
.resolution-wrap {
  padding-top: 10px;
  background: #333B5B;
  margin-top: 50px;
}
.appcase-wrap {
  padding-top: 10px;
  background: #333B5B;
  margin-top: 0;
}
.intro-zhibo-container .application-title .line i {
  background: rgba(202,206,213,.5);
}
</style>



// WEBPACK FOOTER //
// src/view/intro_push.vue